<template>
  <div id="popup"
       @focus="handleFocus"
       @focusout="handleFocusOut"
       tabindex="0"
       ref="frame"
       v-if="isSidebarActiveLocal" :class="isSidebarActiveLocal ? 'active' : ''">

    <div class="popup-cont" tabindex="1">
        <h2 class="popup-heading">{{ this.data.add === true ? "ADD NEW" : "UPDATE" }} PRODUCT</h2>
        <div class="popup-item justify-center">
          <div class="upload-image"><img :src="dataImg"/></div>
          <div class="upload-image-buttons">
            <input type="file" id="tr-upload" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
            <div class="tr-button blue-button list-button" @click="$refs.uploadImgInput.click()">Upload Image</div>
            <div class="tr-button list-button" @click="removeImage">Remove Image</div>
          </div>
        </div>
        <div class="popup-item">
          <h4>Product Name</h4>
          <input type="text" class="pop-input" v-model="name" placeholder="Product Name" name="Product Name" v-validate="'required'"/>

          <span class="text-danger text-sm" v-show="errors.has('Product Name')">{{ errors.first('Product Name') }}</span>
        </div>
        <div class="popup-item">
          <h4>Product Description</h4>
          <textarea class="pop-textarea" placeholder="Description" name="Product Description" v-model="description"></textarea>
          <span class="text-danger text-sm" v-show="errors.has('Product Description')">{{ errors.first('Product Description') }}</span>

        </div>
        <div class="popup-item">
          <h4>Category Select</h4>
          <v-select class="pop-select" placeholder="Select a Category" v-model="selected_section"
                    :options="section_options" :clearable="false"/>
          <span class="text-danger text-sm"
                v-show="errors.has('item-section')">{{ errors.first('item-section') }}</span>
        </div>
        <div class="popup-item">
          <h4>Price</h4>
<!--          <input type="radio" id="one-size" name="size-option" v-model="sizeType" value="single"><label class="pop-radio-label" for="one-size">One
          Size</label>
          <input type="radio" id="multi-size" name="size-option" v-model="sizeType" value="multiple"><label class="pop-radio-label" for="multi-size">Multiple
          Size</label>-->
          <input v-model="price" class="pop-input my-2 py-2" type="number" name="Product Price"/>

          <div v-if="sizeType === 'multiple'">
            <label class="vs-input--label">Sizes</label>
            <v-select class="pop-select" placeholder="Please select a size" v-model="selected_size"
                      :options="size_options" :clearable="false"  v-validate="'required'"/>
            <span class="text-danger text-sm"
                  v-show="errors.has('item-section')">{{ errors.first('item-section') }}</span>
          </div>

        </div>
      <div class="popup-item">
        <h4>Minimum Order Quantity</h4>
        <!--          <input type="radio" id="one-size" name="size-option" v-model="sizeType" value="single"><label class="pop-radio-label" for="one-size">One
                  Size</label>
                  <input type="radio" id="multi-size" name="size-option" v-model="sizeType" value="multiple"><label class="pop-radio-label" for="multi-size">Multiple
                  Size</label>-->
        <input v-model="min_qty" class="pop-input my-2 py-2" type="number" name="Minimum Order Quantity"/>

        <div v-if="sizeType === 'multiple'">
          <label class="vs-input--label">Sizes</label>
          <v-select class="pop-select" placeholder="Please select a size" v-model="selected_size"
                    :options="size_options" :clearable="false"  v-validate="'required'"/>
          <span class="text-danger text-sm"
                v-show="errors.has('item-section')">{{ errors.first('item-section') }}</span>
        </div>

      </div>
        <div class="popup-item">
          <h4>Add Modifiers</h4>
          <div class="w-full">
            <label v-if="modifier_options.filter(val=>val).length > 0" class="pl-0 vs-input--label">Select modifiers for addintional content</label>
            <label v-else class="pl-0 vs-input--label">Modifier options will appear here if added to restaurant</label>

            <div v-for="(modid, index) in modifierId" v-if="!refresh_mods" class="size-item flex flex-wrap items-center" v-bind:key="index" >
              <v-select v-if="modid !== 'undefined'" :value="selected_modifier[index].label" placeholder="Please select a modifier"
                        @input="onModifierChange(modid, index, $event)"
                        :options="modifier_options.filter(val=>val)" :clearable="false"/>
              <feather-icon class="ml-4 mt-5 cursor-pointer" @click="deleteModifier(index)" icon="XIcon"  />
            </div>
          </div>

          <div v-if="modifier_options.filter(val=>val).length > 0" class="w-full">
            <div v-if="modifierId.filter(val=>val).length <= 0" class="mod-button" @click="addModifier(0)"><i class="fas fa-plus"></i> Add Modifier</div>
            <div v-else class="mod-button" @click="addModifier(0)"><i class="fas fa-plus"></i> Add Another</div>

          </div>

        </div>
        <div class="popup-item upload-image-buttons">
          <div class="tr-button blue-button popup-button" @click="submitData" :class="[(!isFormValid ? 'inactive' : '')]">{{ this.data.add === true ? "Add New" : "Update" }} Product</div>
          <div @click="isSidebarActiveLocal = false" class="tr-button popup-button">Cancel</div>
        </div>
    </div>
  </div>
</template>
<script>

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import WeekDayPicker from './components/WeekDayPicker'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    WeekDayPicker,
    ValidationProvider
  },
  data () {
    return {
      restaurantId: null,
      productId: null,
      dataImg: null,
      uploadImg: null,
      name: '',
      description: '',
      sizeType: 'single',
      min_qty: 0,
      sizeId: null,
      price: 0,
      modifierId: [],
      sectionId: null,
      refresh_mods: false,
      progress: 0,
      selected_section: {label: 'Select a section', value: -1},
      section_options: [],
      size_options: [],
      tag_options: [],
      tags: [],
      selected_size: {label: 'Select a size', value: -1},
      modifier_options: [],
      all_modifier_options: [],
      selected_modifier:[{0:{label: 'Select a modifier', value: -1}}],
      hasModifiers: [],
      complete_products: [],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      is_catering: false,
      is_available: true,
      available_for_today: false,
      disabled_period: [],
      disabled_until: new Date(),
      quantity_unit: '',
      quantity_description: '',
      quantity_serves: ''
    }
  },
  mounted () {
    //this.getSectionOptionsList()
  },
  watch: {
    available_for_today () {
      if (this.available_for_today) {
        this.disabled_until = new Date()
        this.disabled_until.setDate(new Date().getDate() + 1)
        this.disabled_until.setHours(0)
        this.disabled_until.setMinutes(0)
        this.disabled_until.setSeconds(0)
      }
    },
    refresh_mods () {
      if (this.refresh_mods) {
        setTimeout(() => {
          this.refresh_mods = false
        }, 200)

      }
    },
    isSidebarActive (val) {
      if (!val) {

        this.$validator.reset()
        return
      }

      this.section_options = this.data.section_options
      this.size_options = this.data.size_options
      this.tag_options = [
        {label: 'Vegan', value: 'vegan'},
        {label: 'Vegetarian', value: 'vegetarian'},
        {label: 'Gluten Free', value: 'gluten-free'},
        {label: 'Spicy', value: 'spicy'}
      ]
      this.modifier_options = this.data.modifier_options
      this.all_modifier_options = JSON.parse(JSON.stringify(this.data.modifier_options))

      if (this.data.add === true) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {name, id, price, description, restaurant_id, is_available, disabled_period, disabled_until, size, section, size_id, min_qty, section_id, hasModifiers, photoUrl, complete_your_meal, is_catering, quantity_description, quantity_unit, quantity_serves, tags} = this.data
        this.productId = id
        this.name = name
        this.price = price
        this.description = description
        this.is_catering = is_catering
        this.quantity_description = quantity_description
        this.quantity_unit = quantity_unit
        this.quantity_serves = quantity_serves
        this.restaurantId = restaurant_id
        this.is_available = is_available
        this.disabled_period = disabled_period === '' ? [] : JSON.parse(disabled_period)
        this.tags = tags
        if (disabled_until !== '' || disabled_until === 'null') {
          this.disabled_until = new Date(disabled_until)
          if (this.disabled_until > new Date()) {
            this.available_for_today = true
          }
        } else {
          this.disabled_until = new Date()
          this.available_for_today = false
        }
        const replMods = []
        hasModifiers.map((mod) => {
          const hasOpt = this.modifier_options.filter(opt => opt.value === mod.modifier.id).length > 0

          if (hasOpt) {
            replMods.push(mod)
          }
        })

        this.hasModifiers = replMods
        if (size !== null) {
          this.selected_size.value = size.id
          this.selected_size.label = size.name
        }
        if (section !== null) {
          this.selected_section.label = section.name
          this.selected_section.value = section.id
        }
        this.sizeId = size_id
        this.min_qty = min_qty
        this.sectionId = section_id
        this.dataImg = (photoUrl !== null) ? photoUrl : require('@/assets/images/pages/register/upload_image.png')
        for (let i = 0; i < this.hasModifiers.length; i++) {
          this.selected_modifier[i] = this.modifier_options[this.hasModifiers[i].modifier_id]
          this.modifierId.push(this.hasModifiers[i].modifier_id)
          delete this.modifier_options[this.hasModifiers[i].modifier_id]
        }

        if (size !== null && price === 0) {
          this.sizeType = 'multiple'
        }
        if (complete_your_meal !== false) {
          this.handleCompleteYourMeal(complete_your_meal)
        }
        //this.initValues()
      }
      return true
    },
    modifierId: {
      deep: true,
      handler () {
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.name && this.selected_section && ((this.sizeType === 'multiple' && this.selected_size) || this.sizeType === 'single')
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    daySelected (index) {
      if (this.disabled_period.includes(index)) {
        const indexOf = this.disabled_period.indexOf(index)
        this.disabled_period.splice(indexOf, 1)
      } else {
        this.disabled_period.push(index)
      }
    },
    handleFocus () {
      // do something here
      this.isSidebarActiveLocal = false
    },
    handleFocusOut () {
      // do something here
    },
    handleCompleteYourMeal (complete_your_meal) {
      complete_your_meal.map((meal) => {
        this.getProduct(meal)
      })
    },
    completeProductFound (value) {
      this.complete_products.push(value)
    },
    deleteCompleteProductItem (index) {
      this.complete_products.splice(index, 1)
    },
    getProduct (product_id) {
      // Loading

      const payload = {
        restaurantId: this.restaurantId,
        productId: product_id
      }

      this.$store.dispatch('api/getProduct', payload)
        .then((response) => {
          this.complete_products.push(response.data.data)
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    initValues () {
      this.productId = null
      this.restaurantId = this.data.restaurantId
      this.name = ''
      this.description = ''
      this.sectionId = null
      this.modifierId = []
      this.sizeType = 'single'
      this.min_qty = 0
      this.sizeId = ''
      this.price = 0
      this.dataImg = require('@/assets/images/pages/register/upload_image.png')
      this.uploadImg = null
      this.section_options = this.data.section_options
      this.tag_options = [
        {label: 'Vegan', value: 'vegan'},
        {label: 'Vegetarian', value: 'vegetarian'},
        {label: 'Gluten Free', value: 'gluten-free'},
        {label: 'Spicy', value: 'spicy'}
      ]
      this.tags = null
      this.size_options = this.data.size_options
      this.selected_modifier = []
      this.modifier_options = this.data.modifier_options
      this.selected_section = {label: 'Select a section', value: -1}
      this.selected_size = {label: 'Select a size', value: -1}
      this.complete_products = []
      this.disabled_until = new Date()
      this.disabled_period = []
      this.is_available = true
      this.is_catering = false
      this.quantity_description = ''
      this.quantity_unit = ''
      this.quantity_serves = ''
    },
    submitData () {

      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()

          const s_modifiers = []
          for (let i = 0; i < this.selected_modifier.length; i++) {
            const mod = this.selected_modifier[i]

            let mod_ref = mod

            if (Array.isArray(mod)) {
              mod_ref = mod[0]
            }

            if (typeof mod_ref !== 'undefined') {

              if (mod_ref.value !== -1) {
                if (typeof  mod.value !== 'undefined') {
                  s_modifiers.push(mod.value)
                }
              }
            }
          }
          const complete_your_meal = []
          this.complete_products.map((cp) => {
            complete_your_meal.push(cp.id)
          })

          const obj = {
            sectionId: this.selected_section.value,
            productId: this.productId,
            name: this.name,
            description: this.description,
            restaurantId: this.restaurantId,
            modifier: (s_modifiers.length > 0) ? s_modifiers : [],
            sizeType: this.sizeType,
            min_qty: this.min_qty,
            sizeId: (this.selected_size.value !== -1) ? this.selected_size.value : null,
            price: (this.sizeType !== 'single') ? 0 : this.price,
            is_catering: this.is_catering ? 1 : 0,
            quantity_description: this.quantity_description,
            quantity_serves: this.quantity_serves,
            quantity_unit: this.quantity_unit,
            is_available: this.is_available,
            disabled_until: !this.available_for_today ? 'null' : this.disabled_until,
            disabled_period: JSON.stringify(this.disabled_period),
            complete_your_meal,
            tags: this.tags
          }

          if (this.uploadImg !== null && this.productId !== null)   {
            const img_obj = {
              file: this.uploadImg,
              productId: this.productId
            }

            this.$store.dispatch('api/uploadImage', img_obj,  event => {
              this.progress = Math.round((100 * event.loaded) / event.total)
            }).then(() => {
              this.$store.dispatch('api/addProduct', obj).then((response) => {
                this.$vs.notify({
                  title: 'Saved product',
                  text: response.data.message,
                  iconPack: 'feather',
                  icon: 'icon-check',
                  color: 'success'
                })
                this.$emit('closeSidebar')
                this.$emit('getProductList')
                this.initValues()
                this.$vs.loading.close()
              }).catch(err => {
                console.error(err)
                this.$vs.notify({
                  title: 'Error',
                  text: err.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })

                this.$emit('getProductList')
                this.$vs.loading.close()
              })
            }).catch(err => {
              console.error(err)
              this.$vs.notify({
                title: 'Error',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })

              this.$emit('getProductList')
              this.$vs.loading.close()
            })
          } else {
            this.$store.dispatch('api/addProduct', obj).then((response) => {

              if (this.productId === null && this.uploadImg !== null) {
                const img_obj = {
                  file: this.uploadImg,
                  productId: response.data.data
                }
                this.$store.dispatch('api/uploadImage', img_obj,  event => {
                  this.progress = Math.round((100 * event.loaded) / event.total)
                }).then((response) => {
                  this.$vs.notify({
                    title: 'Saved product image',
                    text: response.data.message,
                    iconPack: 'feather',
                    icon: 'icon-check',
                    color: 'success'
                  })
                  this.$emit('closeSidebar')
                  this.initValues()
                  this.$emit('getProductList')
                  this.$vs.loading.close()
                }).catch(err => {
                  console.error(err)
                  this.$vs.notify({
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                  })
                  this.$vs.loading.close()
                })
              } else {
                this.$vs.notify({
                  title: 'Saved product',
                  text: response.data.message,
                  iconPack: 'feather',
                  icon: 'icon-check',
                  color: 'success'
                })
                this.$emit('closeSidebar')
                this.initValues()
                this.$emit('getProductList')
                this.$vs.loading.close()
              }

            }).catch(err => {
              console.error(err)
              this.$vs.notify({
                title: 'Error',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
              this.$emit('getProductList')
              this.$vs.loading.close()
            })
          }
        }
      })
    },
    removeImage () {
      this.dataImg = null
      this.$vs.loading()
      const obj = {
        productId: this.productId,
        restaurantId: this.restaurantId
      }
      this.$store.dispatch('api/removeProductImage', obj).then((response) => {
        this.$vs.notify({
          title: 'Image removed',
          text: response.data.message,
          iconPack: 'feather',
          icon: 'icon-check',
          color: 'success'
        })
        this.$vs.loading.close()
      }).catch(err => {
        console.error(err)
        this.$vs.notify({
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        this.$vs.loading.close()
      })

    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
        this.uploadImg = input.target.files[0]
      }
    },
    deleteModifier (index) {
      if (typeof this.selected_modifier[index] !== 'undefined') {
        this.modifier_options[this.selected_modifier[index].value] = this.selected_modifier[index]
        delete this.selected_modifier[index]

        const mod_keys = Object.keys(this.selected_modifier)
        for (let i = 0; i < mod_keys.length; i++) {
          if (mod_keys[i] > index) {
            this.selected_modifier[mod_keys[i] - 1] = this.selected_modifier[mod_keys[i]]
            delete this.selected_modifier[mod_keys[i]]
          }
        }
      }
      this.modifierId.splice(index, 1)
    },
    onModifierChange (modid, index, e) {
      const old_val = this.selected_modifier[index]
      this.modifier_options[old_val.value] = old_val
      this.selected_modifier[index] = e
      this.modifierId[index] = e.value
      delete this.modifier_options[e.value]
      this.refresh_mods = true
    },
    addModifier (val) {
      //const mopt = this.modifier_options.filter(value => JSON.stringify(value) !== '{}')
      const selected_mods = this.selected_modifier.filter(value => JSON.stringify(value) !== '{}')
      const mopt_all = this.all_modifier_options.filter(value => JSON.stringify(value) !== 'null')

      if (selected_mods.length > 0 && this.modifierId.length <= mopt_all.length - 1) {
        this.modifierId.push(val)
        this.selected_modifier[this.modifierId.length - 1] = {}
      } else if (selected_mods.length === 0 && this.modifierId.length <= mopt_all.length - 1) {
        this.modifierId.push(val)
        this.selected_modifier[this.modifierId.length - 1] = {}
      } else {
        this.$vs.notify({
          title: 'Warning',
          text: 'Max number of modifiers reached',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      }
    },
    resetData () {
      this.restaurantId = null
      this.productId = null
      this.dataImg = null
      this.uploadImg = null
      this.name = ''
      this.description = ''
      this.sizeType = 'single'
      this.min_qty = 0
      this.sizeId = null
      this.price = 0
      this.modifierId = []
      this.sectionId = null
      this.progress = 0
      this.selected_section = {label: 'Select a section', value: -1}
      this.section_options = []
      this.size_options = []
      this.tag_options = []
      this.selected_size = {label: 'Select a size', value: -1}
      this.modifier_options = []
      this.selected_modifier = [{0:{label: 'Select a modifier', value: -1}}]
      this.hasModifiers = []
      this.complete_products = []
      this.is_available = true
      this.disabled_until = new Date()
      this.disabled_period = []
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }


  div.v-select {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .size-item .v-select {
    flex: 1;
  }
</style>
